import DialogController from "./dialog_controller"

// Only recipient-guidance routing is specific; dialog lifecycle is shared.
export default class extends DialogController {
  static values = { returnPath: String }

  get initialReturnFocus() {
    return Array.from(document.querySelectorAll("main a[href]"))
      .find(link => link.getAttribute("href") === this.returnPathValue)
  }

  connect() {
    this.autoOpenValue = true
    this.removeOnCacheValue = true
    super.connect()
  }
}
